export const environment = {
	production: true,
	appVersion: require('./app-version').Version.version,
};
